<template>
    <div class="formRightWrap display_center_ud">
        <div class="formBlock">
            <div v-if="callbackurl != ''" class="bianjiaobtn"
                @click="$router.push({ name: 'login', query: { callback: callbackurl } })">电脑登录</div>
            <div v-else class="bianjiaobtn" @click="$router.push({ name: 'login' })">电脑登录</div>
            <img v-if="callbackurl != ''" src="../../assets/img/login/bianjiao.png" alt="" class="bianjiao"
                @click="$router.push({ name: 'login', query: { callback: callbackurl } })" />
            <img v-else src="../../assets/img/login/bianjiao.png" alt="" class="bianjiao"
                @click="$router.push({ name: 'login' })" />
            <div class="login_title">
                <a href="javascript:;">手机扫码，安全登录</a>
            </div>
            <div class="formWrap">
                <div class="text_center marginBottom20" style="width:300upx;height:200px">
                    <wxlogin class="wxlogin" :appid="'wx35e9523a1cb0bcfe'" :scope="'snsapi_login'" :theme="'black'"
                        :redirect_uri="encodeURIComponent(redirecturi)"
                        :href="'data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHsNCiAgZGlzcGxheTogbm9uZTsNCn0NCi5pbXBvd2VyQm94IC5zdGF0dXMuc3RhdHVzX2Jyb3dzZXIgew0KICBkaXNwbGF5OiBub25lOw0KfQ0KLmltcG93ZXJCb3ggLnFyY29kZSB7DQogIGJvcmRlcjogbm9uZTsNCiAgd2lkdGg6IDIwMHB4Ow0KICBoZWlnaHQ6IDIwMHB4Ow0KfQ0KLmltcG93ZXJCb3ggLnN0YXR1c3sNCiAgZGlzcGxheTogbm9uZQ0KfQ=='"
                        rel="external nofollow"></wxlogin>
                </div>
                <p class="text_center marginBottom50">微信扫码登录</p>
                <div class="text_right">
                    <a href="javascript:;" @click="$router.push({ name: 'getpass' })" class="marginRight10">忘记密码？</a>
                    <a href="javascript:;" @click="$router.push({ name: 'loginRegister' })">注册 >></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import wxlogin from 'vue-wxlogin';
export default {
    name: 'sweep',
    components: {
        wxlogin
    },
    data() {
        return {
            callbackurl: '',
            redirecturi: this.httphelper.IsDebugGP519() + '/loginIndex/wechatlogin'
        };
    },
    created() {
        /** 获取callback地址 */
        if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query, 'callback')) {
            this.callbackurl = this.$route.query.callback;
            this.redirecturi += '?callback=' + this.callbackurl;
        }
    }
};
</script>

<style scoped>
/* 每套全部引入 */
/* 每套页面对应的公共样式,每套页面都会引用 */
.wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
}

input {
    height: 40px;
    border: 1px solid #ddd;
    box-sizing: border-box;
    outline: none;
    padding-left: 12px;
}

.title {
    font-size: 110px;
    color: #fff;
    position: relative;
}

.title:before {
    content: '';
    display: inline-block;
    width: 60px;
    height: 5px;
    background: #ffffff;
    border-radius: 2px;
    position: absolute;
    top: -5px;
}

.titleSub {
    font-size: 40px;
    color: #fff;
    margin-bottom: 20px;
}

.english {
    font-size: 16px;
    color: #ffffff;
}

.english:after {
    content: '————';
    margin-left: 10px;
}

.english img {
    vertical-align: middle;
    margin-right: 10px;
}

.width100 {
    width: 100%;
}

.headBar {
    height: 60px;
}

.headBarRight a {
    margin-right: 30px;
}

.headBarRight a img {
    margin-right: 8px;
}

.content {
    min-width: 1300px;
    flex: 1;
    display: flex;
    flex-direction: column;
    background: url('../../assets/img/loginbg.png');
}

.formContent {
    display: flex;
    flex: 1;
}

.formBlock {
    background: #fff;
    width: 340px;
    padding-top: 40px;
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 36px;
    border-radius: 30px 0 30px 0;
    box-sizing: border-box;
    position: relative;
}

.bianjiao {
    position: absolute;
    right: 0;
    top: 0;
}

.bianjiaobtn {
    position: absolute;
    right: 40px;
    top: 13px;
    color: #0b8686;
    font-size: 12px;
    width: 76px;
    height: 22px;
    box-sizing: border-box;
    padding-left: 10px;
    line-height: 22px;
    background: url('../../assets/img/login/bianjaiobtn.png');
}

.login_title {
    border-bottom: 1px solid #ddd;
    font-size: 16px;
    margin-bottom: 30px;
}

.login_title span {
    display: inline-block;
    padding: 0 14px;
    padding-bottom: 10px;
    font-weight: bold;
    color: #0b8686;
    border-bottom: 2px solid #0b8686;
}

.login_title a {
    display: inline-block;
    padding: 0 14px;
    padding-bottom: 10px;
    font-weight: bold;
}

.login_title_active {
    color: #0b8686;
    border-bottom: 2px solid #0b8686;
}

.inputBar {
    display: flex;
    margin-bottom: 20px;
}

.btnNormal {
    display: inline-block;
    height: 40px;
    text-align: center;
    line-height: 40px;
    width: 104px;
    background: #e1e1e1;
}

.btnSubmit {
    width: 100%;
    height: 40px;
    text-align: center;
    display: inline-block;
    line-height: 40px;
    color: #fff;
    background: #0b8686;
}

.footer {
    height: 50px;
    background: rgba(255, 255, 255, 0.05);
}

.beian {
    color: #fff;
}

.footer a {
    color: #fff;
    margin-left: 30px;
}

/* 登录2 */
.successTip {
    height: 240px;
    flex-direction: column;
}

.successTipText {
    font-size: 22px;
    color: #0b8686;
    line-height: 1.6em;
}

.Erro {
    border: 1px solid red;
}
</style>
